import { theme } from '@briq/shared'

export * from './GlobalStyle'

export const createBriqTheme = theme.createBriqTheme

export const defaultTheme = theme.defaultTheme
export const themeColor = theme.themeColor
export const themeTitleFontSize = theme.themeFontSize
export const themeFontSize = theme.themeFontSize
export const themeSpace = theme.themeSpace
export const brkbt = theme.brkbt
export const brkmin = theme.brkmin
export const brkmax = theme.brkmax
export const breakpoint = theme.breakpoint
export const hexToRgb = theme.hexToRgb

export type BriqTheme = theme.BriqTheme
export type Color = theme.Color
export type FontSizes = theme.FontSizes
